module.exports = __webpack_public_path__ + "img/dd1c846.jpg";